import { ofType } from "redux-observable";
import { mergeMap, debounceTime } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_ASYNC_JOBS_COUNT } from "../types";
import {
  getAsyncJobsCountPending,
  getAsyncJobsCountFulfilled,
  setNoEntriesMessage,
  getAsyncJobsCountRejected,
} from "../actions";

import { sendApiRequest, notifyError } from "../../../actions";

import { asyncJobsFiltersSelector } from "../selectors";

import { GET_ASYNC_JOBS_MESSAGES } from "../constants/organizationMessages";
import generateError from "../../../utilities/generateError";

const createPayload = (payload) => ({
  method: "get",
  url: "asyncjobs/count",
  onSuccess: [
    (response) =>
      response.data === 0
        ? setNoEntriesMessage(GET_ASYNC_JOBS_MESSAGES.NOT_FOUND)
        : getAsyncJobsCountFulfilled(response),
    (response) => getAsyncJobsCountFulfilled(response),
  ],
  onError: [
    getAsyncJobsCountRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getAsyncJobsCountEpic$ = (action$, state$) =>
  action$.pipe(
    ofType(GET_ASYNC_JOBS_COUNT.DEFAULT),
    debounceTime(500),
    mergeMap(({ payload }) => {
      const filters = asyncJobsFiltersSelector(state$.value);
      return merge(
        of(getAsyncJobsCountPending()),
        of(sendApiRequest(createPayload({ ...payload, ...filters }), meta))
      );
    })
  );

export default getAsyncJobsCountEpic$;



// WEBPACK FOOTER //
// ./src/features/organization/epics/getAsyncJobsCountEpic.js